module.exports = __webpack_public_path__ + "static/img/zhfh.98b417b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/zhfh.jpg
// module id = R3Ug
// module chunks = 11